<template>
  <div class="app-modal-body">
    <div class="message-wrapper has-text-centered">
      <p>{{ message }}</p>
    </div>

    <div class="columns">
      <div class="column has-text-centered">
        <a
          v-if="downloadUrl" 
          :href="downloadUrl" 
          :download="filename"
          class="btn confirm"
          @click="confirm"
        >
          {{ $t('global.download') }}
        </a>
      </div>
    </div >

  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ModalDownload',
  props: {
    message: {
      type: String,
      required: true
    },
    downloadUrl: {
      type: String,
      required: true
    }
  },
  computed: {
    filename() {
      if (!this.downloadUrl) return '';
      const baseUrl = this.downloadUrl.split('?')[0];
      return baseUrl.split('/').pop();
    }
  },
  methods: {
    ...mapActions('appStore', ['closeModal']),
    confirm () {
      this.$emit('modalDownloadConfirmed')
    }
  }
}
</script>

<style scoped lang="scss">
.message-wrapper {
  margin: 30px 0;
}

</style>
